import {
	SwiperStateActions,
	SET_DRAG_ITEM_ID,
	SET_SELECTED_ITEM_ID,
	SET_ITEMS_IN_MODULE_SWIPER,
	SET_MODULE_ITEMS_CHANGED,
	SET_SWIPER_EVENT_TYPE,
} from './types';
import { IModuleSwiperItem } from 'sofa-reborn-react';

export function setItemsInModuleSwiper(value: Array<IModuleSwiperItem>): SwiperStateActions {
	return {
		type: SET_ITEMS_IN_MODULE_SWIPER,
		value,
	};
}

export function setDragItemId(
	value: string | null,
	origin: 'swiper' | 'scene'
): SwiperStateActions {
	return {
		type: SET_DRAG_ITEM_ID,
		value,
		origin,
	};
}

export function setSwiperEventType(value: {
	type: 'click' | 'drag' | null;
	productId: string | null;
}): SwiperStateActions {
	return {
		type: SET_SWIPER_EVENT_TYPE,
		value,
	};
}

export function setSelectedItemId(value: string | null): SwiperStateActions {
	return {
		type: SET_SELECTED_ITEM_ID,
		value,
	};
}

export function setModuleItemsChanged(value: boolean): SwiperStateActions {
	return {
		type: SET_MODULE_ITEMS_CHANGED,
		value,
	};
}
